export const environment = {
  production: false,
  baseUrl: 'https://blessed-moss-t3iqcbqyh8ug.vapor-farm-d1.com/api',
  credentials: null,
  sentryUrl: 'https://3ef488d1933141249bffb75d106c25bc@sentry.emendis.nl/78',
  name: 'test',
};
